module.exports = __webpack_public_path__ + "static/media/course3.89e87e2f.png";